import "./index.scss";
import { BannerDownloadAppProps } from "./types";
import { Button } from "@wise-emotions/react-button";
import { GeneralSmallClose } from "@wise-emotions/react-icons";
import { navigate } from "gatsby";
import IconWrap from "components/Icon/IconWrap";
import Image from "components/Image";
import React, { useEffect, useRef, useState } from "react";
import cookies from "js-cookie";

export const BannerCookie = "is_hidden_banner";

const BannerDownloadApp = ({
  imageIconApp,
  title,
  text,
  buttonLabel,
  buttonLink,
}: BannerDownloadAppProps) => {
  const bannerDownloadApp = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const className = "download-app-banner";

  useEffect(() => {
    setIsVisible(cookies.get(BannerCookie) !== "true");
  }, []);

  const onSaveCookie = () => {
    if (bannerDownloadApp.current) {
      if (isVisible) {
        bannerDownloadApp.current.classList.add("animated-close");
      }
    }
    cookies.set(BannerCookie, "true", { expires: 60 });
  };

  if (isVisible) {
    return (
      <div data-testid="banner" className={className} ref={bannerDownloadApp}>
        <div className={`${className}__wrapper`}>
          <div className={`${className}__icon-close`}>
            <button
              // TODO add correct aria label ( not hardcoded value )
              aria-label="Chiudi"
              data-testid="close-button"
              type="button"
              onClick={() => onSaveCookie()}
            >
              <IconWrap>
                <GeneralSmallClose />
              </IconWrap>
            </button>
          </div>
          <div className={`${className}__icon-app`}>
            <Image {...imageIconApp} />
          </div>
          <div className={`${className}__text-wrapper`}>
            {title && <div className={`${className}__title`}>{title}</div>}
            {text && <div className={`${className}__text`}>{text}</div>}
          </div>
          <div data-testid="cta" className={`${className}__cta`}>
            <Button
              variant="default"
              size="sm"
              theme="primary"
              onClick={() => buttonLink && navigate(buttonLink)}
            >
              {buttonLabel}
            </Button>
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default BannerDownloadApp;
